const _excluded = ["children"],
  _excluded2 = ["name", "className", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import { getArchiveIcon } from "../../tools";
import { Spinner } from '@isyc-react/design/bootstrap';
import { ViewArchiveInfo } from "./view-archive-info.component";
import '@isyc-react/design/main';
export const ViewArchiveInfoLoading = props => {
  const {
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(ViewArchiveInfo, rest, children, /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    className: "text-primary"
  }));
};
export const ViewArchiveInfoLoadingIcon = props => {
  const {
      name,
      className,
      children
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const classes = React.useMemo(() => getArchiveIcon(name), [name]);
  return /*#__PURE__*/React.createElement(ViewArchiveInfoLoading, _extends({
    className: clsx('flex-column', className)
  }, rest), /*#__PURE__*/React.createElement("i", {
    className: clsx(classes.icon, 'font-size-90')
  }), children);
};